<div class="dp-host">
  <button
    class="dp-trigger"
    type="button"
    aria-haspopup="dialog"
    [attr.aria-expanded]="open()"
    [attr.aria-label]="ariaLabel() + ' ' + displayDate()"
    (click)="toggle()"
  >
    <i class="ri-calendar-line text-sm" aria-hidden="true"></i>
    {{ displayDate() }}
  </button>
</div>

<ng-template #dropdownTpl>
  <div
    class="dp-dropdown"
    role="dialog"
    [attr.aria-label]="ariaLabel()"
    [style.top.px]="dropdownTop() ?? null"
    [style.bottom.px]="dropdownBottom() ?? null"
    [style.left.px]="dropdownLeft() ?? null"
  >
      <div class="dp-nav">
        <button
          type="button"
          class="dp-nav-btn"
          aria-label="Předchozí měsíc"
          (click)="prevMonth()"
        >
          <i class="ri-arrow-left-s-line text-sm" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="dp-month-label dp-month-label-btn"
          [attr.aria-pressed]="mode() === 'years'"
          aria-label="Vybrat rok"
          (click)="toggleYears()"
        >
          {{ viewMonthLabel() }}
          <i class="ri-arrow-down-s-line text-sm" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="dp-nav-btn"
          aria-label="Další měsíc"
          (click)="nextMonth()"
        >
          <i class="ri-arrow-right-s-line text-sm" aria-hidden="true"></i>
        </button>
      </div>

      @if (mode() === 'years') {
        <div class="dp-years">
          <div class="dp-nav dp-years-nav">
            <button
              type="button"
              class="dp-nav-btn"
              aria-label="Předchozí roky"
              (click)="prevYears()"
            >
              <i class="ri-arrow-left-s-line text-sm" aria-hidden="true"></i>
            </button>
            <span class="dp-years-label">{{ yearsLabel() }}</span>
            <button
              type="button"
              class="dp-nav-btn"
              aria-label="Další roky"
              (click)="nextYears()"
            >
              <i class="ri-arrow-right-s-line text-sm" aria-hidden="true"></i>
            </button>
          </div>
          <div class="dp-years-grid" role="grid" aria-label="Výběr roku">
            @for (y of yearsGrid(); track y) {
              <button
                type="button"
                class="dp-year"
                role="gridcell"
                [class.is-current]="isViewYear(y)"
                (click)="selectYear(y)"
              >
                {{ y }}
              </button>
            }
          </div>
        </div>
      } @else {
        <div class="dp-grid" role="grid">
          @for (d of dayLabels; track d) {
            <div class="dp-day-label" aria-hidden="true">{{ d }}</div>
          }
          @for (day of calendarDays(); track day.date.toISOString()) {
            <button
              type="button"
              class="dp-day"
              role="gridcell"
              [attr.aria-label]="dayAria(day.date)"
              [attr.aria-selected]="isSel(day.date)"
              [attr.aria-current]="day.isToday ? 'date' : null"
              [class.out-of-month]="!day.inMonth"
              [class.is-today]="day.isToday"
              [class.is-selected]="isSel(day.date)"
              (click)="selectDay(day.date)"
            >
              {{ day.date.getDate() }}
            </button>
          }
        </div>
      }

      <div class="dp-footer">
        <button type="button" class="dp-today-btn" (click)="goToday()">
          Dnes
        </button>
      </div>
    </div>
</ng-template>

